import { useCallback, useMemo, useState } from "react"

/** Server grid page that resets to 0 when filter inputs change (no effect). */
export const usePrecomputedGridPage = (resetKey: string) => {
  const [pageState, setPageState] = useState({ resetKey, page: 0 })
  const page = pageState.resetKey === resetKey ? pageState.page : 0

  const setPage = useCallback(
    (nextPage: number) => {
      setPageState({ resetKey, page: nextPage })
    },
    [resetKey]
  )

  return { page, setPage }
}

export const usePrecomputedGridPageResetKey = (
  filters: unknown,
  dateRange: unknown,
  extra?: unknown
) =>
  useMemo(
    () => JSON.stringify({ filters, dateRange, extra }),
    [filters, dateRange, extra]
  )
